var _rect, _path, _path2, _path3, _rect2, _rect3, _path4, _path5, _path6, _rect4, _rect5, _path7, _path8, _path9, _rect6, _rect7, _path10, _rect8, _path11, _rect9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistencePhoneFreeTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 145,
    viewBox: "0 0 285 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EB5756"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6924 54.3848L19.0001 90.0771",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0771 57.5667V53.7689C46.0771 53.0891 45.5261 52.5381 44.8464 52.5381H25.1541C24.4743 52.5381 23.9233 53.0891 23.9233 53.7689V78.7447C23.9233 79.293 24.5862 79.5675 24.9738 79.1799L45.7167 58.437C45.9475 58.2062 46.0771 57.8932 46.0771 57.5667Z",
    fill: "#24284E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9229 85.664V88.2311C23.9229 88.9109 24.4739 89.4619 25.1536 89.4619H44.8459C45.5257 89.4619 46.0767 88.9109 46.0767 88.2311V64.486C46.0767 63.9378 45.4138 63.6632 45.0262 64.0509L24.2833 84.7937C24.0525 85.0246 23.9229 85.3376 23.9229 85.664Z",
    fill: "#24284E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.38462,
    height: 1.84615,
    rx: 0.923077,
    transform: "matrix(-1 0 0 1 38.6924 54.3848)",
    fill: "#EB5756"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EB5756"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.692 54.3848L115 90.0771",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.077 57.5667V53.7689C142.077 53.0891 141.526 52.5381 140.846 52.5381H121.154C120.474 52.5381 119.923 53.0891 119.923 53.7689V78.7447C119.923 79.293 120.586 79.5675 120.974 79.1799L141.717 58.437C141.947 58.2062 142.077 57.8932 142.077 57.5667Z",
    fill: "#24284E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.923 85.664V88.2311C119.923 88.9109 120.474 89.4619 121.154 89.4619H140.846C141.526 89.4619 142.077 88.9109 142.077 88.2311V64.486C142.077 63.9378 141.414 63.6632 141.026 64.0509L120.283 84.7937C120.053 85.0246 119.923 85.3376 119.923 85.664Z",
    fill: "#24284E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.38462,
    height: 1.84615,
    rx: 0.923077,
    transform: "matrix(-1 0 0 1 134.692 54.3848)",
    fill: "#EB5756"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 186.999,
    y: 31,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EB5756"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.614 50.2305L206.999 94.8459",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.845 54.2087V49.4613C240.845 48.6116 240.156 47.9229 239.306 47.9229H214.691C213.841 47.9229 213.152 48.6116 213.152 49.4613V80.6812C213.152 81.3665 213.981 81.7097 214.466 81.2251L240.394 55.2965C240.683 55.008 240.845 54.6167 240.845 54.2087Z",
    fill: "#24284E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213.153 89.3298V92.5387C213.153 93.3884 213.842 94.0771 214.692 94.0771H239.307C240.157 94.0771 240.846 93.3884 240.846 92.5387V62.8573C240.846 62.172 240.017 61.8288 239.532 62.3134L213.604 88.2419C213.315 88.5304 213.153 88.9218 213.153 89.3298Z",
    fill: "#24284E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.23077,
    height: 2.30769,
    rx: 1.15385,
    transform: "matrix(-1 0 0 1 231.614 50.2305)",
    fill: "#EB5756"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 101L159.5 105L166.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 101L63.5 105L70.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 138,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 28,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 128.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 129.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 27.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.5 9.5L194.5 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M259 12L250.5 25.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234 128.5L240 143",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistencePhoneFreeTime);
export default __webpack_public_path__ + "static/media/persistence-phone-free-time.3cf9282b6c433acb34b595aacee18659.svg";
export { ForwardRef as ReactComponent };